<template>
  <AppHeader fixed>
    <SidebarToggler class="d-lg-none mobileToggle" display="md" mobile />
    <b-link class="navbar-brand" to="#">
      <img
        class="navbar-brand-full"
        src="img/brand/Logo-transparent.png"
        width="109"
        height="35"
        alt="CoreUI Logo"
      />
      <img
        class="navbar-brand-minimized"
        src="img/brand/sygnet.svg"
        width="30"
        height="30"
        alt="CoreUI Logo"
      />
    </b-link>
    <SidebarToggler
      class="c-header-toggler-icon desktopToggle"
      display="lg"
      :defaultOpen="true"
    />
    <b-navbar-nav class="ml-auto">
      <DefaultHeaderDropdownAccnt />
    </b-navbar-nav>
    <!--<AsideToggler class="d-lg-none" mobile />-->
  </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";

export default {
  name: "DefaultHeader",
  components: {
    AsideToggler,
    AppHeader,
    DefaultHeaderDropdownAccnt,
    SidebarToggler,
  },
};
</script>
